import { useState, useEffect } from "react";

// Lightweight, localStorage-backed "view another member's NHL predictions" mode.
// Scoped by the consuming pages (NHL Schedule + NHL Standings) only.
const KEY = "rosterly_nhl_emulate";
const EVT = "rosterly-emulate-change";
const CTX = "rosterly_league_ctx";   // league whose swap bar stays open (also while viewing "You")

export function getLeagueCtx() { try { return localStorage.getItem(CTX) || null; } catch { return null; } }
export function exitLeagueView() {
    try { localStorage.removeItem(CTX); localStorage.removeItem(KEY); } catch { /* noop */ }
    try { window.dispatchEvent(new CustomEvent(EVT)); } catch { /* noop */ }
}
export function useLeagueCtx() {
    const [lid, setLid] = useState(getLeagueCtx);
    useEffect(() => {
        const h = () => setLid(getLeagueCtx());
        window.addEventListener(EVT, h); window.addEventListener("storage", h);
        return () => { window.removeEventListener(EVT, h); window.removeEventListener("storage", h); };
    }, []);
    return lid;
}

export function getEmulation() {
    try { return JSON.parse(localStorage.getItem(KEY) || "null"); } catch { return null; }
}

export function setEmulation(val) {
    try {
        if (val && val.uid) localStorage.setItem(KEY, JSON.stringify({ uid: val.uid, name: val.name || "Player", lid: val.lid || null }));
        else localStorage.removeItem(KEY);
        if (val?.lid) localStorage.setItem(CTX, val.lid);
    } catch { /* noop */ }
    try { window.dispatchEvent(new CustomEvent(EVT)); } catch { /* noop */ }
}

export function useEmulation() {
    const [emu, setEmu] = useState(getEmulation);
    useEffect(() => {
        const h = () => setEmu(getEmulation());
        window.addEventListener(EVT, h);
        window.addEventListener("storage", h);
        return () => { window.removeEventListener(EVT, h); window.removeEventListener("storage", h); };
    }, []);
    return emu;
}
